import CirclePieSVG from '@public/icons/circle-pie.svg';
import { AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';
import CloseButton from '@/shared/components/configurator/CloseButton';
import ConstructorButton from '@/shared/components/configurator/ConstructorButton';
import {
    useConfiguratorOpenedCameraPositionValue,
    useSetCameraPosition,
} from '@/shared/components/configurator/atoms/camera-position';
import { useSetConfiguratorStepState } from '@/shared/components/configurator/atoms/configurator-step-state';
import { useConfiguratorZoomedSetState } from '@/shared/components/configurator/atoms/configurator-zoomed';
import {
    useCurrentModelStateValue,
    useSetCurrentModelState,
} from '@/shared/components/configurator/atoms/current-model-state';
import { CONFIGURATOR_WALL_COLOR_DEFAULT, CONFIGURATOR_WALL_NO_COLORS_TEXT } from '@/shared/config/const';
import Typografed from '../../shared/Typografed';
import ConfiguratorWallColorPicker from './ConfiguratorWallColorPicker';

const ConfiguratorColor = () => {
    const setStep = useSetConfiguratorStepState();
    const setCameraPosition = useSetCameraPosition();
    const configuratorOpenedCameraPosition = useConfiguratorOpenedCameraPositionValue();
    const setConfiguratorZoomed = useConfiguratorZoomedSetState();
    const { color, openedWallColorPickerIndex } = useCurrentModelStateValue();
    const setCurrentModelState = useSetCurrentModelState();

    const pickedColors = color.value.map((color) => (color ? color.toLowerCase() : color));

    useEffect(() => {
        return () => {
            setCurrentModelState((prev) => ({
                ...prev,
                openedWallColorPickerIndex: null,
            }));
        };
    }, []);

    return (
        <div className="configurator">
            <div className="configurator-top">
                <div className="configurator-title text-l">Цвет панелей</div>
                <CloseButton
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                />
            </div>

            {color.value.some((value) => !!value) ? (
                <ul className="list-unstyled configurator-color-list">
                    {color.value.map((value, i) => (
                        <li key={i} className="configurator-color-list__item">
                            <button
                                className="configurator-color-item"
                                onClick={() => {
                                    setCurrentModelState((prev) => ({
                                        ...prev,
                                        openedWallColorPickerIndex: i,
                                    }));
                                }}
                            >
                                <div className="configurator-color-item__icon">
                                    <CirclePieSVG />
                                </div>
                                <div className="configurator-color-item__title text-l">{`Панель №${i + 1}`}</div>
                                <div className="configurator-color-item__color-container">
                                    {value ? (
                                        <div className="configurator-color-item__color text-s">
                                            <div className="configurator-color-item__color-value">{value}</div>
                                            <div
                                                className="configurator-color-item__color-preview"
                                                style={{ backgroundColor: value }}
                                            ></div>
                                        </div>
                                    ) : (
                                        CONFIGURATOR_WALL_NO_COLORS_TEXT
                                    )}
                                </div>
                            </button>
                        </li>
                    ))}
                </ul>
            ) : (
                <div className="configurator-color-tip">
                    <div className="configurator-color-tip__icon">
                        <CirclePieSVG />
                    </div>
                    <div className="text-s configurator-color-tip__text">
                        <Typografed>Выберите панель для покраски</Typografed>
                    </div>
                </div>
            )}

            <div className="configurator-hero-buttons configurator-color-picker-buttons">
                {pickedColors.some((color) => !!color) && (
                    <ConstructorButton
                        variant="outline"
                        onClick={() => {
                            setCurrentModelState((prev) => {
                                return {
                                    ...prev,
                                    color: {
                                        title: CONFIGURATOR_WALL_COLOR_DEFAULT,
                                        value: [null, null, null, null, null],
                                    },
                                };
                            });
                        }}
                    >
                        Удалить все
                    </ConstructorButton>
                )}
                <ConstructorButton
                    variant="blue"
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                >
                    {pickedColors.some((color) => !!color) ? 'Сохранить и закрыть' : 'Закрыть'}
                </ConstructorButton>
            </div>

            <AnimatePresence>
                {typeof openedWallColorPickerIndex === 'number' && <ConfiguratorWallColorPicker />}
            </AnimatePresence>
        </div>
    );
};

export default ConfiguratorColor;
